
<header class="top-nav">
	<div class="nav-content">
		<a class="brand" routerLink="/" aria-label="Go to Home">
			<picture>
				<source srcset="assets/img/footer/Ascendiun_Black-S.png" media="(max-width: 767px)">
				<source srcset="assets/img/footer/Ascendiun_Black-M.png" media="(min-width: 768px) and (max-width: 1023px)">
				<source srcset="assets/img/footer/Ascendiun_Black-L.png" media="(min-width: 1024px)">
				<img class="brand-logo" src="assets/img/footer/Ascendiun_Black-XL.png" alt="Ascendiun"/>
			</picture>
		</a>
		<nav class="nav-links" aria-label="Primary">
			<a *ngIf="!isPressReleaseScreen()" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">← Back to Home</a>
			<a *ngIf="isPressReleaseScreen()" routerLink="/news" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">← Back to News</a>
		</nav>
	</div>
</header>
